import { Button, makeStyles, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  inputFileText: {
    margin: theme.spacing(1)
  }
}))

function UploadExcelDialog(props) {
  const { onDataChange } = props;
  const classes = useStyles();
  const { t } = useTranslation('incidentManagement');

  const [file, setFile] = useState();

  const onFileChange = (file) => {
    setFile(file);
    onDataChange(file);
  }

  return (
    <React.Fragment>
      <form className={classes.root}>
        <input
          id='file-input'
          hidden
          type='file'
          accept=".xlsx, .xls, .csv"
          onChange={(event) => { onFileChange(event.target.files[0]) }}
        />
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <label htmlFor='file-input' style={{ flex: 1 }}>
            <Button color="secondary" variant='contained' component="span">
              {t('common:select_file')}
            </Button>
          </label>
          <Typography
            className={classes.inputFileText}
            variant='body2'
            align='left'
            noWrap
            style={{ flex: 2, width: '100%' }}
          >
            {(file && file.name) || t('common:file_select_message')}
          </Typography>
        </div>
      </form>
    </React.Fragment>
  )
}

UploadExcelDialog.defaultProps = {
  branches: [],
  onDataChange: () => { }
}

export default UploadExcelDialog